import { State } from '../state';

export const MeshDeviceSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    deviceRegistration: (state: State) => state.MeshDevice,
};